import { render, staticRenderFns } from "./Entreprenerds.vue?vue&type=template&id=0c9da6f2&scoped=true"
import script from "./Entreprenerds.vue?vue&type=script&lang=js"
export * from "./Entreprenerds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9da6f2",
  null
  
)

export default component.exports